/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateAssetRelationDto { 
    fromEntity: string;
    fromEntityId: string;
    toEntity: string;
    toEntityId: string;
    relationshipType: string;
}

